import { TweenLite, TweenMax, Power2 } from 'gsap';

const componentDidmountAnimation = () => {
    // TODO: find a way to target react references

    const heroTitles = document.querySelectorAll('.Hero-content-title');
    const heroDescs = document.querySelectorAll('.Hero-content-description');
    const heroActions = document.querySelectorAll('.Hero-actions');
    const heroActionArrows = document.querySelectorAll('.Hero-actions-arrow');

    if (heroTitles) {
        heroTitles.forEach(heroTitle => {
            TweenLite.to(heroTitle, 0.3, {
                delay: 0.3,
                opacity: 1,
                y: 0,
                ease: Power2.easeIn,
            });
        });
    }

    if (heroDescs) {
        heroDescs.forEach(heroDesc => {
            TweenLite.to(heroDesc, 0.3, {
                opacity: 1,
                y: 0,
                delay: 0.5,
                ease: Power2.easeIn,
            });
        });
    }

    if (heroActions) {
        heroActions.forEach(heroAction => {
            TweenLite.to(heroAction, 0.3, {
                opacity: 1,
                y: 0,
                delay: 0.8,
                ease: Power2.easeIn,
            });
        });
    }

    if (heroActionArrows) {
        heroActionArrows.forEach(heroActionArrow => {
            TweenLite.to(heroActionArrow, 0.3, {
                opacity: 1,
                delay: 1,
                ease: Power2.easeIn,
            });
            TweenMax.to(heroActionArrow, 1, {
                y: 10,
                delay: 1.8,
                ease: Power2.easeIn,
                repeat: -1,
                yoyo: true,
            });
        });
    }
};
export { componentDidmountAnimation };
